const vhCalc =()=> {

    const identity = "VH Calculator"

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    devSays(identity,2,'1 vh =',vh,'px');

};//recalculates vh unit

let coverSlider = null;
let slidersArray = [];

const createGlideSliders =()=> {

    const identity = "Glider Init";

    if ( document.getElementById('cover') && document.querySelectorAll('#cover .glide__slide').length) {

        let counterSum = document.querySelector('#cover .sum');
        counterSum.innerHTML = document.querySelectorAll('#cover .glide__slide').length;
        coverSlider = new Glide('#cover',{
            gap: 0,
            type: 'carousel',
            autoplay: 2000,
            animationDuration: 1000,
            hoverpause: false,
        }).mount();

        let counterIndex = document.querySelector('#cover .index');
        counterIndex.innerHTML = 1;

        coverSlider.on('run', function() {
            counterIndex.innerHTML = coverSlider.index + 1;
        });

        barathLayout.sfpInit('cover');


    }// creating cover slider

    if ( document.querySelector('.slider') ) {




        let sliders = document.querySelectorAll('.slider');


        for (let i = 0; i < sliders.length; i++) {

            sliders[i].id = "slider-"+i;
            let counterSum = document.querySelector('#slider-'+i+' + .n_counter .sum');
            if ( !(document.querySelectorAll('#slider-'+i+' .glide__slide').length) ) {
                return;
            }
            counterSum.innerHTML = document.querySelectorAll('#slider-'+i+' .glide__slide').length;

            slidersArray[i] = new Glide('#slider-'+i,{
                gap: 0,
                type: 'carousel',
                autoplay: 2000,
                animationDuration: 1000,
                hoverpause: false,
            }).mount();

            let counterIndex = document.querySelector('#slider-'+i+' + .n_counter .index');
            counterIndex.innerHTML = 1;
            
            slidersArray[i].on('run', function() {
                counterIndex.innerHTML = slidersArray[i].index + 1;
            });

        }

    }


}

const devSays =(from,priority,message,value,unit)=> {
    
    if(from == undefined) { from = '-unknown-';}
    if(priority != 1 && priority != 2 && priority != 3 ) { priority = 2;}
    if(message == undefined) { return; }
    if(value == undefined) { value = '';}
    if(unit == undefined) { unit = '';}

    var date = new Date();

    function twoDigits(num) {
        return (num < 10 ? '0': '') + num; 
    }

    var time = twoDigits( date.getHours() ) + ":" + twoDigits( date.getMinutes() ) + ":" + twoDigits( date.getSeconds() );

    if(developerModeLevel >= priority) {
        let extramarker = "   ";
        if (priority == 1) {
            extramarker = " • ";
        } else if  (priority == 2) {
            extramarker = " . ";
        }
        console.log(


`  | ${from} (${time})
   ${extramarker}${message} ${value}${unit}
  
`

        );
    }

};

const consoleGreatings =()=> {
    if(!developerModeLevel) {
        console.log(consoleGreatingsText);
    }
}


function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

function isHomePage() {
    return document.body.classList.contains('n_home-page');
}

function isSingleWorkPage() {
    return document.body.classList.contains('n_work');
}

function detectFeatures() {
    if (isTouchDevice()) {
        document.body.classList.add('hasTouch');
    } else {
        document.body.classList.add('hasNoTouch');
    }
}

function animateOnScroll() {
    const items = document.querySelectorAll(".animate-on-scroll")

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("animate")
            }
        })
    }
    const options = {}

    const myObserver = new IntersectionObserver(callback, options);
    items.forEach(item => myObserver.observe(item));
}

function setCloseButtonHref() {
    if (window.localStorage.getItem("closeButtonHref") !== null) {
        document.getElementById("n_close-button").setAttribute("href", window.localStorage.getItem("closeButtonHref"));
    }
}

function savePosition() {
    window.localStorage.setItem("closeButtonPosition", window.scrollY);
}

function restorePosition() {
    if (window.localStorage.getItem("closeButtonPosition") !== null) {
        window.scrollTo(0, window.localStorage.getItem("closeButtonPosition"));
        window.localStorage.removeItem("closeButtonPosition");
    }
}

function debounce(func, timeout = 3150){
    let timer;
    return (...args) => {
        if (!timer) {
            func.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(() => {
            timer = undefined;
        }, timeout);
    };
}